import { useEffect, useCallback } from 'react';
/* import { Api } from '@plone/volto/helpers';


export const getURLAuth = async (req) => {
  const api = new Api();
  const response = await api.get('/@portal-login');
  return response;
};

export const getURLAuthCallback = async (req) => {
  const api = new Api();
  const response = await api.post('/@portal-callback', req.query);
  return response;
}; */

export const getYoutubeVideoId = (url) => {
  let videoID = null;
  let listID = null;

  if (/youtu\.?be/.test(url)) {
    let i;
    const patterns = [
      /youtu\.be\/([^#&?]{11})/, // youtu.be/<id>
      /\?v=([^#&?]{11})/, // ?v=<id>
      /&v=([^#&?]{11})/, // &v=<id>
      /embed\/([^#&?]{11})/, // embed/<id>
      /\/v\/([^#&?]{11})/, // /v/<id>
    ];

    for (i = 0; i < patterns.length; ++i) {
      if (patterns[i].test(url)) {
        videoID = patterns[i].exec(url)[1];
      }
    }

    if (url.match('list')) {
      const id = /[&|?]list=([a-zA-Z0-9_-]+)/gi.exec(url);
      listID = id && id.length > 0 ? id[1] : null;
    }
  }
  return { videoID, listID };
};

export const getYoutubeImage = (url, size) => {
  const videoID = getYoutubeVideoId(url).videoID;
  let imgYoutube = '';
  const sizes = {
    default: 'default.jpg',
    medium: 'mqdefault.jpg',
    high: 'hqdefault.jpg',
    standard: 'standard.jpg',
    maxres: 'maxresdefault.jpg',
  };
  if (videoID) {
    imgYoutube = `https://img.youtube.com/vi/${videoID}/${sizes[size]}`;
  }
  return imgYoutube;
};

export const useDebouncedEffect = (effect, delay, deps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(effect, deps);

  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};

export const parseBool = (value) => {
  const isBool = ['true', 'false'].includes(value) ? value : null;
  // eslint-disable-next-line no-eval
  return isBool ? eval(value) : null;
};
